import React, { useContext, useEffect, useState } from "react";
import "./Trending.css";
import Common_Heading from "../../../common_components/common_Heading/Common_Heading";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Trending_card from "./trending_card/Trending_card";
import { luxuryLatestNewsTrending } from "../../../../utils/luxuryapis/Home/Homeapi";
import { Context } from "../../../../utils/context";

function Trending() {
  const [latestnews, setLatestNews] = useState();
  const { IMG_URL } = useContext(Context);
  const getAllLuxuryLatestNews = async () => {
    const res = await luxuryLatestNewsTrending();
    if (res?.success) {
      setLatestNews(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryLatestNews();
  }, []);
  return (
    <>
      <section className="Trending">
        <div className="custom_container">
          <Common_Heading headingText={"TRENDING"} />
          <div className="Trending_swiper">
            <Swiper
              spaceBetween={20}
              slidesPerView={5.2}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                0: {
                  slidesPerView: 1.5,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 2.2,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 3.2,
                  spaceBetween: 18,
                },
                1024: {
                  slidesPerView: 4.2,
                  spaceBetween: 20,
                },
                1280: {
                  slidesPerView: 5.2,
                  spaceBetween: 20,
                },
              }}
            >
              {latestnews?.map((val) => (
                <SwiperSlide>
                  <Trending_card val={val} imgSrc={IMG_URL + val?.image} />
                </SwiperSlide>
              ))}

              {/* <SwiperSlide>
                <Trending_card
                  imgSrc={
                    "/assest/luxury_images/in_company/latest_news/trending/img_2.png"
                  }
                />
              </SwiperSlide>

              <SwiperSlide>
                <Trending_card
                  imgSrc={
                    "/assest/luxury_images/in_company/latest_news/trending/img_3.png"
                  }
                />
              </SwiperSlide>

              <SwiperSlide>
                <Trending_card
                  imgSrc={
                    "/assest/luxury_images/in_company/latest_news/trending/img_1.png"
                  }
                />
              </SwiperSlide>

              <SwiperSlide>
                <Trending_card
                  imgSrc={
                    "/assest/luxury_images/in_company/latest_news/trending/img_2.png"
                  }
                />
              </SwiperSlide>

              <SwiperSlide>
                <Trending_card
                  imgSrc={
                    "/assest/luxury_images/in_company/latest_news/trending/img_3.png"
                  }
                />
              </SwiperSlide> */}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Trending;
